/* Albeux reviews.
   1. The heading count and the overall rating (stars and score) are drawn by the section itself from the live (active) bags only,
      so they are always visible and never read from the widget.
   2. When a bag has no reviews of its own, Judge.me lists reviews from the other bags. Any review whose product is not on the live list
      (data-active-handles on the section) is hidden, so draft, archived and deleted products never show.
      A review is judged by the product link or data-product-url on its card. If the cards on the page do show product links, a card with
      no product at all (a deleted product) is hidden too. If no card shows a product link, nothing is hidden (a safety stop, so the list is never emptied by mistake).
   3. Judge.me's own "Customer Reviews" title and its "Be the first to write a review" line are removed (our heading already says it).
      If the "Be the first" text is the write-a-review button itself, the button is kept and reads "Write a review".
   4. The review text copies the exact computed type style of the product title into CSS custom properties on the section,
      so the two always match, including at the 750px breakpoint. */
(function () {
  'use strict';

  var root = document.querySelector('.albeux-reviews');
  if (!root || root.__albeuxReviews) return;
  root.__albeuxReviews = true;

  var holder = root.querySelector('.albeux-reviews__widget');
  var scope = root.getAttribute('data-scope') || 'all';

  var activeSet = {};
  var activeCount = 0;
  try {
    var list = JSON.parse(root.getAttribute('data-active-handles') || '[]');
    for (var a = 0; a < list.length; a++) {
      activeSet[String(list[a]).toLowerCase()] = true;
      activeCount++;
    }
  } catch (e) {
    activeCount = 0;
  }

  function ownText(el) {
    var out = '';
    for (var i = 0; i < el.childNodes.length; i++) {
      if (el.childNodes[i].nodeType === 3) out += el.childNodes[i].nodeValue;
    }
    return out.replace(/\s+/g, ' ').trim();
  }

  var firstReview = /^be the first to write a review\.?$/i;
  var widgetTitle = /^customer reviews?$/i;

  function cleanWidget() {
    if (!holder) return;
    var nodes = holder.querySelectorAll('*');
    var limit = Math.min(nodes.length, 2000);
    for (var i = 0; i < limit; i++) {
      var el = nodes[i];
      var text = ownText(el);
      if (!text || text.length > 40) continue;

      if (widgetTitle.test(text)) {
        if (el.children.length === 0) {
          if (!el.hasAttribute('data-albeux-hidden')) el.setAttribute('data-albeux-hidden', '');
        } else {
          for (var k = 0; k < el.childNodes.length; k++) {
            if (el.childNodes[k].nodeType === 3 && el.childNodes[k].nodeValue.trim()) el.childNodes[k].nodeValue = '';
          }
        }
      } else if (firstReview.test(text) && el.children.length === 0) {
        if (el.matches('a, button, [class*="write-rev"], [role="button"]')) {
          el.textContent = 'Write a review';
        } else if (!el.hasAttribute('data-albeux-hidden')) {
          el.setAttribute('data-albeux-hidden', '');
        }
      }
    }
  }

  function handleOf(card) {
    var url = card.getAttribute('data-product-url') || '';
    if (!url) {
      var link = card.querySelector('a[href*="/products/"]');
      if (link) url = link.getAttribute('href') || '';
    }
    var m = url.match(/\/products\/([^\/?#]+)/);
    if (!m) return '';
    try {
      return decodeURIComponent(m[1]).toLowerCase();
    } catch (e) {
      return m[1].toLowerCase();
    }
  }

  function filterInactive() {
    if (!holder || scope !== 'all' || activeCount === 0) return;
    var cards = holder.querySelectorAll('.jdgm-rev, [data-review-id]');
    if (!cards.length) return;

    var handles = [];
    var detected = 0;
    var i;
    for (i = 0; i < cards.length; i++) {
      var h = handleOf(cards[i]);
      handles.push(h);
      if (h) detected++;
    }
    if (detected === 0) return;

    for (i = 0; i < cards.length; i++) {
      var inactive = !handles[i] || !activeSet[handles[i]];
      if (inactive && !cards[i].hasAttribute('data-albeux-hidden')) {
        cards[i].setAttribute('data-albeux-hidden', '');
      }
    }
  }

  var typeProps = [
    ['--alb-t-family', 'fontFamily'],
    ['--alb-t-size', 'fontSize'],
    ['--alb-t-weight', 'fontWeight'],
    ['--alb-t-case', 'textTransform'],
    ['--alb-t-track', 'letterSpacing'],
    ['--alb-t-lh', 'lineHeight'],
    ['--alb-t-color', 'color']
  ];

  function syncType() {
    var title =
      document.querySelector("main[data-template^='product'] .product-details h1") ||
      document.querySelector("main[data-template^='product'] h1");
    if (!title) return;
    var cs = window.getComputedStyle(title);
    for (var i = 0; i < typeProps.length; i++) {
      var value = cs[typeProps[i][1]];
      if (value && value !== 'normal') root.style.setProperty(typeProps[i][0], value);
    }
  }

  function syncAll() {
    cleanWidget();
    filterInactive();
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      syncAll();
    });
  }

  var resizeQueued = false;
  function onResize() {
    if (resizeQueued) return;
    resizeQueued = true;
    window.requestAnimationFrame(function () {
      resizeQueued = false;
      syncType();
    });
  }

  syncType();
  syncAll();
  window.addEventListener('resize', onResize, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncType);
  window.addEventListener('load', function () {
    syncType();
    syncAll();
  });

  if (holder && 'MutationObserver' in window) {
    new MutationObserver(queue).observe(holder, { childList: true, subtree: true, characterData: true });
  }
})();